import GameSceneImage from '../../Inamove/Components/GameSceneImage/GameSceneImage'
import Level, { LevelActionsAction } from '../../Inamove/Components/Level'
import { takeableObjectActionType } from '../../Inamove/Components/TakeableObject'
import Video from '../../Inamove/Components/Video/Video'
import { waypointOpenActionCreator } from '../../Inamove/Components/Waypoint'
import CinematicContainer from '../../Inamove/Containers/CinematicContainer/CinematicContainer'
import Config from '../../Inamove/Containers/Config'
import GameSceneContainer from '../../Inamove/Containers/GameSceneContainer/GameSceneContainer'
import InventoryContainer from '../../Inamove/Containers/InventoryContainer/InventoryContainer'
import LoadingContainer from '../../Inamove/Containers/LoadingContainer/LoadingContainer'
import AudioController from '../../Inamove/Controllers/AudioController'
import LevelController from '../../Inamove/Controllers/LevelController'
import LoadingController from '../../Inamove/Controllers/LoadingController'
import dispatch from '../../Inamove/Utility/dispatchAction'

export default async function () {
    InventoryContainer.clean()
    CinematicContainer.hide()
    GameSceneContainer.hide()
    LoadingController.reset()
    LoadingContainer.show()

    const V2 = new Video(Config.CINEMATIC_PATH + 'V2' + Config.VIDEO_FILE_EXT)
    LoadingController.addToQueue(V2)
    CinematicContainer.setVideo(V2)

    const level = await LevelController.loadLevel('level1')

    const bueroKlammernExtraAudioId = AudioController.add(
        Config.GAME_SCENE_PATH + 'K2/audio/nichts-gemerkt' + Config.AUDIO_FILE_EXT
    )

    const bueroKlammernK1 = new GameSceneImage(Config.GAME_SCENE_PATH + 'K1/K1-bueroklammern.png')
    LoadingController.addToQueue(bueroKlammernK1)
    level.gameScenes.K1.addImage(bueroKlammernK1)

    addEventListener(takeableObjectActionType, (event) => {
        // @ts-ignore -- wrong event typings - does not include CustomEvent
        if (event.detail.takeableObject.id === 'büroklammern') {
            level.gameScenes.K1.removeImage(bueroKlammernK1)
            AudioController.play(bueroKlammernExtraAudioId)
        }
    })

    addEventListener('Inventory.added', (event) => {
        // @ts-ignore
        if (event.detail.itemId === 'I4') {
            dispatch(waypointOpenActionCreator('level2'))
        }
    })

    await AudioController.addAllToLoadingQueue()

    await LoadingController.processQueue()
    await LoadingContainer.clickStart()

    GameSceneContainer.hide()
    InventoryContainer.hide()
    CinematicContainer.show()
    LoadingContainer.hide()

    await CinematicContainer.play()

    CinematicContainer.hide()
    GameSceneContainer.show()
    LevelController.startLevel('level1')

    return new Promise<void>((resolve) => {
        addEventListener('Level', (event) => {
            // @ts-ignore
            const action: LevelActionsAction = event.detail.action
            // @ts-ignore
            const level: Level = event.detail.level

            if (action === LevelActionsAction.stop && level.id === 'level1') {
                resolve()
                level.destroy()
            }
        })
    })
}
